<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (!projectStateService.isAreaPlannerProject()) {
    <form name="editForm" novalidate>
        @if (sector) {
            <h6 class="mr-1 font-size-14">
                Frequency: <span id="sectorFrequency">{{ sectorFrequencyChannel }}</span>
            </h6>
            <div class="d-flex mb-2 align-items-center">
                <span class="p-0 mb-0 font-size-12 {{ historyService.isEditModeEnabled ? 'col-6' : 'col-8' }}">
                    Sector angle:
                    @if (historyService.isEditModeEnabled) {
                        <small class="d-block sector-range"
                            >Range [<span class="sector-range__min">{{ sectorAngleMinMax.min }}</span
                            >..<span class="sector-range__max">{{ sectorAngleMinMax.max }}</span
                            >]
                        </small>
                    }
                </span>
                @if (
                    historyService.isEditModeEnabled &&
                    !projectStateService.isBomConfigProject() &&
                    !projectStateService.isPotentiallyCorruptedProject()
                ) {
                    <div class="col-6 p-0 mb-0">
                        <input
                            type="number"
                            name="sectorAngle"
                            id="sectorAngle"
                            step="1"
                            class="form-control form-control-sm angle-input font-size-12"
                            [(ngModel)]="sectorAngle"
                            windeAngleInputValidation
                            [(inputVal)]="sectorAngle"
                            (inputValChange)="changeAngle($event)"
                            [angleMinMax]="sectorAngleMinMax"
                        />
                    </div>
                } @else {
                    <span class="col-4 mb-0 p-0 font-size-12">
                        <span id="sectorAngle">{{ sectorAngle }}</span
                        >°
                    </span>
                }
            </div>
            @if (
                historyService.isEditModeEnabled &&
                !projectStateService.isBomConfigProject() &&
                !projectStateService.isPotentiallyCorruptedProject()
            ) {
                <div class="d-flex mb-2 align-items-center">
                    <span class="p-0 mb-0 font-size-12 col-6">Link frequency:</span>
                    <div class="col-6 p-0 mb-0">
                        @if (sectorFrequencies?.length > 1) {
                            <select
                                class="form-control form-control-sm angle-input p-0 font-size-12"
                                name="frequencySelection"
                                id="link_frequency_select"
                                [ngModel]="sectorFrequency"
                                (ngModelChange)="changeSectorFrequency($event)"
                            >
                                <option [ngValue]="frequencySetAutomatically">{{ sectorAutoFrequencyText }}</option>
                                @for (frequency of sectorFrequencies; track frequency) {
                                    <option [ngValue]="frequency">{{ frequency }}</option>
                                }
                            </select>
                        }
                        @if (sectorFrequencies.length === 1) {
                            <span class="mb-0 font-size-12">{{ sectorFrequencies[0] }}</span>
                        }
                    </div>
                </div>
            }
            @if (
                historyService.isEditModeEnabled &&
                !projectStateService.isBomConfigProject() &&
                !projectStateService.isPotentiallyCorruptedProject()
            ) {
                @if (unfrozenLinks && historyService.selectedStepNumber !== stepGroupEnum.LOCATIONS_AND_LOSES) {
                    <div>
                        <button
                            class="btn btn-link btn-sm font-size-12"
                            [disabled]="unfrozenLinks.length === 0"
                            (click)="toggleFreezeLinks(unfrozenLinks, true, false)"
                            id="sectorFreeze"
                        >
                            Freeze links (<span class="links-counter">{{ unfrozenLinks.length }}</span
                            >)
                        </button>
                    </div>
                }
                @if (frozenLinks) {
                    <div>
                        <button
                            class="btn btn-link btn-sm font-size-12"
                            [disabled]="frozenLinks.length === 0"
                            (click)="toggleFreezeLinks(frozenLinks, false, false)"
                            id="sectorUnfreeze"
                        >
                            Unfreeze links (<span class="links-counter">{{ frozenLinks.length }}</span
                            >)
                        </button>
                    </div>
                }
                @if (notInstalledLinks && historyService.selectedStepNumber !== stepGroupEnum.LOCATIONS_AND_LOSES) {
                    <div>
                        <button
                            class="btn btn-link btn-sm font-size-12"
                            id="unInstalledLinks"
                            [disabled]="notInstalledLinks.length === 0"
                            (click)="toggleFreezeLinks(notInstalledLinks, true, true)"
                        >
                            Mark links as installed (<span class="links-counter">{{ notInstalledLinks.length }}</span
                            >)
                        </button>
                    </div>
                }
                @if (installedLinks) {
                    <div>
                        <button
                            class="btn btn-link btn-sm font-size-12"
                            id="installedLinks"
                            [disabled]="installedLinks.length === 0"
                            (click)="toggleFreezeLinks(installedLinks, true, false)"
                        >
                            Unmark links as installed (<span class="links-counter">{{ installedLinks.length }}</span
                            >)
                        </button>
                    </div>
                }
            }
        }
    </form>
}
